/* unplugin-vue-components disabled */import script from "./MainButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainButton.vue?vue&type=script&lang=ts&setup=true"

import "./MainButton.vue?vue&type=style&index=0&id=65ac9ffa&lang=less"

const __exports__ = script;

export default __exports__